function addZero(time) {
  return (time < 10 ? "0" : "") + time;
}

export default function formatTime(time) {
  const seconds = Math.floor(time / 1000) % 60;
  const minutes = Math.floor(time / (60 * 1000)) % 60;
  const hours = Math.floor(time / (1000 * 60 * 60) % 24);

  const hh = addZero(hours);
  const mm = addZero(minutes);
  const ss = addZero(seconds);

  if (hours > 0) {
    return `${hh}:${mm}:${ss}`;
  }

  return `${mm}:${ss}`;
}



// WEBPACK FOOTER //
// ./src/components/Tabs/formatTime.js